import { CartLinesUpdateEvent } from '@shopify/events';

let addPending = false;

class AlteireProductUpsells extends HTMLElement {
  connectedCallback() {
    this.addEventListener('submit', this.addProduct);
    this.addEventListener('change', this.changeVariant);
  }

  disconnectedCallback() {
    this.removeEventListener('submit', this.addProduct);
    this.removeEventListener('change', this.changeVariant);
  }

  changeVariant = (event) => {
    const select = event.target.closest('[data-upsell-variant]');
    if (!select || !this.contains(select)) return;
    const option = select.selectedOptions[0];
    if (!option?.value) return;
    const row = select.closest('[data-upsell-row]');
    const price = row.querySelector('[data-upsell-price]');
    const compare = row.querySelector('[data-upsell-compare]');
    price.textContent = option.dataset.price;
    price.classList.toggle('alteire-pp-upsells__price--sale', Boolean(option.dataset.compare));
    compare.textContent = option.dataset.compare || '';
    compare.hidden = !option.dataset.compare;
    select.form.elements.quantity.value = option.dataset.quantity || '1';
    row.querySelector('[role="alert"]').hidden = true;
  };

  addProduct = async (event) => {
    const form = event.target.closest('form');
    if (!form || !this.contains(form)) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (addPending || button.disabled || !form.reportValidity()) return;
    const formData = new FormData(form);
    const variantId = String(formData.get('id') || '');
    const quantity = Number(formData.get('quantity')) || 1;
    if (!variantId) return;
    const errorElement = form.querySelector('[role="alert"]');
    const status = this.querySelector('[data-upsell-status]');
    const oldLabel = button.textContent;
    const oldCount = Number(document.querySelector('#cart-drawer [ref="cartItemCount"]')?.textContent) || 0;
    const deferred = CartLinesUpdateEvent.createPromise();
    deferred.promise.catch(() => {});
    addPending = true;
    button.disabled = true;
    button.textContent = this.dataset.adding;
    form.setAttribute('aria-busy', 'true');
    errorElement.hidden = true;
    status.textContent = '';

    this.dispatchEvent(new CartLinesUpdateEvent({
      action: 'add',
      context: 'product',
      lines: [{ merchandiseId: variantId, quantity }],
      promise: deferred.promise,
    }));

    try {
      const sections = [...new Set([...document.querySelectorAll('cart-items-component[data-section-id]')].map(element => element.dataset.sectionId))].slice(0, 5);
      const response = await fetch(this.dataset.addUrl, {
        method: 'POST', credentials: 'same-origin',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ items: [{ id: variantId, quantity }], sections, sections_url: window.location.pathname }),
      });
      const result = await response.json();
      if (!response.ok || result.status) throw new Error(typeof result.description === 'string' ? result.description : this.dataset.error);
      let ajaxCart;
      try {
        const cartResponse = await fetch(this.dataset.cartUrl, { credentials: 'same-origin', headers: { Accept: 'application/json' } });
        if (cartResponse.ok) ajaxCart = await cartResponse.json();
      } catch {}
      const sectionDocument = new DOMParser().parseFromString(result.sections?.['cart-drawer-section'] || '', 'text/html');
      const renderedCount = sectionDocument.querySelector('[ref="cartItemCount"]')?.textContent;
      const itemCount = ajaxCart?.item_count ?? (renderedCount ? Number(renderedCount) : oldCount + quantity);
      deferred.resolve({
        ...(ajaxCart ? { cart: CartLinesUpdateEvent.createCartFromAjaxResponse(ajaxCart) } : {}),
        detail: { sections: result.sections, items: ajaxCart?.items, itemCount, didError: false, source: 'alteire-product-upsells' },
      });
      status.textContent = this.dataset.added;
    } catch (error) {
      deferred.reject(error);
      errorElement.textContent = error.message || this.dataset.error;
      errorElement.hidden = false;
    } finally {
      addPending = false;
      form.removeAttribute('aria-busy');
      button.disabled = false;
      button.textContent = oldLabel;
    }
  };
}

if (!customElements.get('alteire-product-upsells')) customElements.define('alteire-product-upsells', AlteireProductUpsells);
